export const environment = {
    apiUrl: 'https://ticketing.exab-training.com/api/',
    baseUrl: 'https://ticketing.exab-training.com/'
};
